/** عرض viewport که از آن به بعد چیدمان «دسکتاپ» در نظر گرفته می‌شود */
export const RESPONSIVE_LAYOUT_MAX_WIDTH = 767;

export function isLikelyMobileDevice() {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }
    const ua = String(navigator.userAgent || '').toLowerCase();
    const mobileByUa =
        /android|iphone|ipod|blackberry|iemobile|opera mini|mobile/i.test(ua) ||
        (/ipad|tablet/i.test(ua) && !/macintosh/i.test(ua));
    const coarsePointer =
        typeof window.matchMedia === 'function' ? window.matchMedia('(pointer: coarse)').matches : false;
    const narrowViewport =
        typeof window.innerWidth === 'number' ? window.innerWidth <= RESPONSIVE_LAYOUT_MAX_WIDTH + 200 : false;
    return mobileByUa || (coarsePointer && narrowViewport);
}

/** viewport باریک (ریسپانسیو) — مستقل از نوع دستگاه */
export function isResponsiveViewport() {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= RESPONSIVE_LAYOUT_MAX_WIDTH;
}

/** موبایل یا حالت ریسپانسیو — برای انتخاب renderer PDF */
export function isMobileOrResponsiveViewport() {
    return isLikelyMobileDevice() || isResponsiveViewport();
}

export function isIosDevice() {
    if (typeof navigator === 'undefined') return false;
    const ua = String(navigator.userAgent || '').toLowerCase();
    return /iphone|ipod|ipad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function isAndroidDevice() {
    if (typeof navigator === 'undefined') return false;
    return /android/i.test(String(navigator.userAgent || ''));
}

/**
 * روی موبایل از نمایشگر native مرورگر استفاده می‌کنیم.
 * pdf.js برای PDF فارسی حروف را جدا و به‌هم‌ریخته رندر می‌کند.
 */
export function shouldPreferMobilePdfRenderer() {
    return isMobileOrResponsiveViewport();
}

/** @deprecated gview در iframe embed نمی‌شود */
export function shouldUseGooglePdfViewer() {
    return false;
}
